import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class WorkLogApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'workLog'
  }


  /**
   * 导出
   * @returns
   */
  public excel(month,userId,userName) {
    return this.download({}, "excel?month="+month+"&userId="+userId+"&userName="+userName)
  }

  /**
   * 项目成果
   * @param month
   * @param userName
   */
  public getUserProjectList(month,userName) {
    return this.send({}, "getUserProjectList?month="+month+"&userName="+userName, this.Methods.GET);
  }




}
